module.exports = __webpack_public_path__ + "static/media/p1_2.eb0fc14f.png";